import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Header } from 'Components/Common';
import { Voting } from 'Components/Ticket';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { ButtonActions, ButtonActionsWhite } from 'Components/UI';
import { formattingDigitCurrency } from 'utils/FormattingDigit';
import { Link, useHistory } from 'react-router-dom';
import { useAtom } from 'jotai';
import {
  ticketAtom,
  goToPayAtom,
  amountToPayAtom,
  stepPaymentTicketAtom,
  feedbackCookingAtom,
  feedbackServiceAtom,
} from 'Atoms/Ticket';
import { staticDataAtom } from 'Atoms/Common';

// import { useAtomDevtools } from 'jotai/devtools';

const useStyles = makeStyles((theme) => ({
  root: theme.containerGrid,
  voting: { margin: '2rem 0' },
  restToPay: { margin: '2rem 0' },
  title: { ...theme.title, fontSize: '60px' },
  subTitle: theme.subTitle,
  subTitle2: { ...theme.subTitle2, marginTop: '1rem' },
  oldPrice: {
    textDecoration: 'line-through',
  },
}));

const Payment = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const [ticket] = useAtom(ticketAtom);
  const [, setGoToPay] = useAtom(goToPayAtom);
  const [staticData] = useAtom(staticDataAtom);
  const [amountToPay] = useAtom(amountToPayAtom);
  const [, setStepPaymentTicket] = useAtom(stepPaymentTicketAtom);
  const [feedbackCooking, setFeedbackCooking] = useAtom(feedbackCookingAtom);
  const [feedbackService, setFeedbackService] = useAtom(feedbackServiceAtom);
  //useAtomDevtools(amountToPayAtom);

  const { id, order } = ticket || {};
  const { totals } = order || {};
  const { countryCode, labelCode } = staticData?.currency;
  const [disabledHover, setDisabledHover] = useState(true);

  const totalAmount = formattingDigitCurrency(
    amountToPay,
    countryCode,
    labelCode,
  );
  const oldTotalAmount = formattingDigitCurrency(
    totals.amount,
    countryCode,
    labelCode,
  );

  const totalAmountToPayDifferentTotalTicket =
    amountToPay !== totals.amount ? true : false;
  const labelButtonAction = `${t('pay_rest')} (${totalAmount})`;

  const redirect = (e) => {
    const tipsDisabled = ticket.tips && ticket.tips.enable === false;
    const to = tipsDisabled ? `/ticket/:${id}/pay/form` : `/ticket/:${id}/tips`;

    e.preventDefault();
    setStepPaymentTicket('checkout');
    setGoToPay(true);
    setTimeout(() => history.push(to), 100);
  };

  const redirectShare = (e, to) => {
    e.preventDefault();
    setDisabledHover(false);
    setTimeout(() => history.push(to), 100);
  };
  return (
    <>
      <Header
        title={t('my_ticket')}
        actions={{
          prev: { icon: 'cancel', label: t('cancel'), path: `/ticket/:${id}` },
        }}
      ></Header>
      <Grid
        container
        className={classes.root}
        justifyContent="center"
        alignContent="center"
        alignItems="center"
      >
        <Grid item className={classes.restToPay}>
          <Typography align="center" className={classes.subTitle}>
            {t('rest_to_pay')}
          </Typography>
          <Typography align="center" className={classes.title}>
            {totalAmount}
          </Typography>
          <Typography align="center" className={classes.subTitle}>
            {t('total')}
            {t(':')}{' '}
            <span
              className={`${
                totalAmountToPayDifferentTotalTicket && classes.oldPrice
              }`}
            >
              {oldTotalAmount}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={11} className={classes.voting}>
          {staticData?.feedback.cooking ? (
            <>
              <Typography align="center" className={classes.subTitle2}>
                {t('appreciateDishes')}
              </Typography>
              <Grid align="center">
                <Voting
                  name={'rating-cooking'}
                  saveRate={function (newRate) {
                    setFeedbackCooking(newRate);
                  }}
                  rate={0}
                />
              </Grid>
            </>
          ) : (
            <></>
          )}
          {staticData?.feedback.service ? (
            <>
              <Typography align="center" className={classes.subTitle2}>
                {t('appreciateService')}
              </Typography>
              <Grid align="center">
                <Voting
                  name={'rating-service'}
                  saveRate={function (newRate) {
                    setFeedbackService(newRate);
                  }}
                  rate={0}
                />
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={11}>
          {amountToPay > 0 ? (
            <>
              <Typography align="center" className={classes.subTitle2}>
                {t('how_would_you_like_to_pay')}
              </Typography>
              <Link to={{}} onClick={(e) => redirect(e)}>
                <ButtonActions label={labelButtonAction} color="secondary" />
              </Link>
              <Link
                to={{}}
                onClick={(e) => redirectShare(e, `/ticket/:${id}/share`)}
              >
                <ButtonActions
                  label={t('share_bill')}
                  styles={{
                    background: 'backgroundWhite',
                    label: 'labelRed',
                    hover: disabledHover,
                  }}
                  color="default"
                />
              </Link>
            </>
          ) : (
            <>
              <Typography align="center" className={classes.subTitle2}>
                {t('nothing_to_pay')}
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

Payment.propTypes = {};

export default Payment;
